import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <h4 className="text-lg font-heading font-bold text-background-50 mb-4">羞羞漫画</h4>
              <p className="text-sm text-background-50/60 leading-relaxed">
                国内领先的正版成人漫画在线阅读平台，汇聚海量精品漫画，每日更新，高清阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">分类浏览</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">恋爱言情</Link></li>
                <li><Link to="/category/urban" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">都市生活</Link></li>
                <li><Link to="/category/fantasy" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">奇幻冒险</Link></li>
                <li><Link to="/category/xianxia" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">古风仙侠</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="text-sm text-background-50/60">邮箱：service@xiuxiumanhua.com</li>
                <li className="text-sm text-background-50/60">微信：xiuxiumanhua</li>
                <li className="text-sm text-background-50/60">微博：@羞羞漫画官方微博</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; 2026 羞羞漫画 版权所有 | 本站所有漫画均获正版授权
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}